"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/tabs/style/index.js
// module id = 95
// module chunks = 1